/**
 * ARRULLA — sistema propio de interacción (independiente de global.js).
 * Senior build notes: un único archivo, sin dependencias, con guardas por
 * si el bloque no existe en la página. Respeta prefers-reduced-motion.
 */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealOnScroll() {
    var targets = document.querySelectorAll('.af-reveal');
    if (!targets.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  function heroWordCascade() {
    document.querySelectorAll('[data-af-cascade]').forEach(function (el) {
      if (el.dataset.afBound) return;
      el.dataset.afBound = 'true';
      var text = el.textContent;
      var words = text.split(' ');
      el.innerHTML = words.map(function (w, i) {
        var delay = reduced ? 0 : i * 70;
        return '<span class="af-word" style="animation-delay:' + delay + 'ms">' + w + '&nbsp;</span>';
      }).join('');
    });
  }

  function faqAccordions() {
    document.querySelectorAll('.af-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.af-faq__item');
        var panel = item.querySelector('.af-faq__a');
        var open = item.classList.contains('is-open');
        var group = item.closest('[data-af-faq-group]');
        if (group) {
          group.querySelectorAll('.af-faq__item.is-open').forEach(function (other) {
            if (other !== item) {
              other.classList.remove('is-open');
              other.querySelector('.af-faq__a').style.maxHeight = null;
            }
          });
        }
        if (open) {
          item.classList.remove('is-open');
          panel.style.maxHeight = null;
        } else {
          item.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  function heroTilt() {
    if (reduced) return;
    var art = document.querySelector('[data-af-tilt]');
    var wrap = document.querySelector('[data-af-tilt-zone]');
    if (!art || !wrap) return;
    wrap.addEventListener('mousemove', function (e) {
      var rect = wrap.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      art.style.transform = 'rotateY(' + (x * 8) + 'deg) rotateX(' + (y * -8) + 'deg)';
    });
    wrap.addEventListener('mouseleave', function () {
      art.style.transform = 'rotateY(0deg) rotateX(0deg)';
    });
  }

  function gallery() {
    var track = document.querySelector('[data-af-gallery-track]');
    var slides = track ? Array.from(track.querySelectorAll('[data-af-slide]')) : [];
    var thumbs = Array.from(document.querySelectorAll('[data-af-thumb]'));
    if (!track || !slides.length) return;

    function goTo(index) {
      var clamped = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.dataset.afThumb, 10) || 0);
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
    document.querySelectorAll('[data-af-variant-image]').forEach(function (input) {
      input.addEventListener('change', function () {
        var src = input.dataset.afVariantImage;
        var idx = slides.findIndex(function (s) { return s.dataset.afSlideSrc === src; });
        if (idx > -1) goTo(idx);
      });
    });
  }

  function variantSync() {
    var wrap = document.querySelector('[data-af-buybox]');
    if (!wrap) return;
    var dataEl = wrap.querySelector('[data-af-variants-json]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent || '[]');
    var mainInput = wrap.querySelector('[data-af-variant-id-input]');
    var priceEl = wrap.querySelector('[data-af-price-now]');

    function money(cents) {
      return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    function sync() {
      var checked = wrap.querySelector('[data-af-variant-image]:checked');
      if (!checked) return;
      var id = checked.dataset.afVariantId;
      var variant = variants.find(function (v) { return String(v.id) === String(id); });
      if (!variant) return;
      if (mainInput) mainInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
    }
    wrap.querySelectorAll('[data-af-variant-image]').forEach(function (input) {
      input.addEventListener('change', sync);
    });
  }

  function beforeAfter() {
    document.querySelectorAll('[data-af-ba]').forEach(function (root) {
      if (root.dataset.afBaBound) return;
      root.dataset.afBaBound = 'true';

      var frame = root.querySelector('.af-ba__frame');
      var handle = root.querySelector('[data-af-ba-handle]');
      if (!frame || !handle) return;
      var dragging = false;

      function setPos(clientX) {
        var rect = frame.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        root.style.setProperty('--af-ba-pos', pct + '%');
        handle.setAttribute('aria-valuenow', Math.round(pct));
      }
      function clientX(e) {
        if (e.touches && e.touches.length) return e.touches[0].clientX;
        return e.clientX;
      }
      function onMove(e) {
        if (!dragging) return;
        setPos(clientX(e));
      }
      function onUp() { dragging = false; }
      function onDown(e) {
        dragging = true;
        setPos(clientX(e));
      }

      handle.addEventListener('pointerdown', onDown);
      frame.addEventListener('pointerdown', onDown);
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);
      window.addEventListener('pointercancel', onUp);

      handle.addEventListener('keydown', function (e) {
        var current = parseFloat(root.style.getPropertyValue('--af-ba-pos')) || 50;
        if (e.key === 'ArrowLeft') current = Math.max(0, current - 5);
        else if (e.key === 'ArrowRight') current = Math.min(100, current + 5);
        else if (e.key === 'Home') current = 0;
        else if (e.key === 'End') current = 100;
        else return;
        e.preventDefault();
        root.style.setProperty('--af-ba-pos', current + '%');
        handle.setAttribute('aria-valuenow', Math.round(current));
      });
    });
  }

  function bundlePicker() {
    var wrap = document.querySelector('[data-af-bundle]');
    if (!wrap) return;
    var radios = wrap.querySelectorAll('input[name="af-bundle-qty"]');

    function sync() {
      var checked = wrap.querySelector('input[name="af-bundle-qty"]:checked');
      wrap.querySelectorAll('[data-af-bundle-option]').forEach(function (opt) {
        var isSelected = opt.contains(checked);
        opt.classList.toggle('is-selected', isSelected);
        var next = opt.nextElementSibling;
        var merged = isSelected && !!(next && next.hasAttribute('data-af-bundle-swatches'));
        opt.classList.toggle('af-bundle__option--merged', merged);
      });
      if (checked) {
        wrap.dataset.qty = checked.value;
        wrap.dataset.code = checked.dataset.discountCode || '';
      }
      updateActionButtons();
    }
    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();
  }

  function bundleSwatches() {
    document.querySelectorAll('[data-af-bundle-swatches]').forEach(function (group) {
      var need = parseInt(group.dataset.need, 10) || 1;
      var buttons = Array.from(group.querySelectorAll('[data-af-bundle-swatch]'));
      var hint = group.querySelector('[data-af-bundle-swatches-hint]');

      function picked() {
        return buttons.filter(function (b) { return b.classList.contains('is-picked'); });
      }
      function refresh() {
        var chosen = picked();
        buttons.forEach(function (b) {
          var isPicked = b.classList.contains('is-picked');
          b.disabled = !isPicked && chosen.length >= need;
        });
        group.dataset.selectedIds = chosen.map(function (b) { return b.dataset.variantId; }).join(',');
        if (hint) {
          hint.textContent = chosen.length + ' / ' + need + ' colores elegidos';
          hint.classList.toggle('is-complete', chosen.length === need);
        }
        updateActionButtons();
      }
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('is-picked')) {
            btn.classList.remove('is-picked');
          } else if (picked().length < need) {
            btn.classList.add('is-picked');
          }
          refresh();
        });
      });
      refresh();
    });
  }

  function bundleContext() {
    var bundle = document.querySelector('[data-af-bundle]');
    var buybox = document.querySelector('[data-af-buybox]');
    var mainInput = buybox ? buybox.querySelector('[data-af-variant-id-input]') : null;
    var qty = bundle ? parseInt(bundle.dataset.qty || '1', 10) : 1;
    var code = bundle ? bundle.dataset.code : '';
    var items = [];

    if (qty > 1) {
      var group = document.querySelector('[data-af-bundle-swatches][data-need="' + qty + '"]');
      var ids = group && group.dataset.selectedIds ? group.dataset.selectedIds.split(',').filter(Boolean) : [];
      items = ids.map(function (id) { return { id: id, quantity: 1 }; });
    } else if (mainInput && mainInput.value) {
      items = [{ id: mainInput.value, quantity: 1 }];
    }

    return {
      items: items,
      quantity: qty,
      code: code,
      complete: items.length === qty && items.length > 0
    };
  }

  function updateActionButtons() {
    var ctx = bundleContext();
    var addBtn = document.querySelector('[data-af-add-to-cart]');
    var buyBtn = document.querySelector('[data-buy-now]');
    if (addBtn) addBtn.disabled = !ctx.complete;
    if (buyBtn) buyBtn.disabled = !ctx.complete;
  }

  function bundleAddToCart() {
    var btn = document.querySelector('[data-af-add-to-cart]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var ctx = bundleContext();
      if (!ctx.complete) return;
      document.body.dispatchEvent(new CustomEvent('amansa:add-bundle', {
        detail: { items: ctx.items }
      }));
      if (ctx.code) {
        fetch(window.Shopify.routes.root + 'discount/' + ctx.code).catch(function () {});
      }
    });
  }

  function buyNow() {
    document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var form = btn.closest('form');
        var ctx = bundleContext();
        if (!ctx.complete) return;
        var originalLabel = btn.textContent;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: ctx.items })
        })
          .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
          .then(function () {
            window.location.href = ctx.code ? ('/discount/' + ctx.code + '?redirect=/checkout') : '/checkout';
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = originalLabel;
            if (ctx.quantity === 1 && form) form.submit();
          });
      });
    });
  }

  // Imágenes de color solo para el carrito: el picker de pack necesita
  // swatches planos y la galería no debe duplicar estas fotos, así que NO
  // se tocan las imágenes de variante en Shopify. Aquí se sustituye el
  // <img> de cada línea del carrito por variant id, solo en el panel lateral.
  function cartImageOverrides() {
    var overrides = {
      '58810535510347': 'https://cdn.shopify.com/s/files/1/1002/1706/1707/files/Unknown-14.png?v=1791937501',
      '58810535543115': 'https://cdn.shopify.com/s/files/1/1002/1706/1707/files/Unknown-15.png?v=1791937502',
      '58810535575883': 'https://cdn.shopify.com/s/files/1/1002/1706/1707/files/Unknown-16.png?v=1791937502'
    };
    var container = document.querySelector('[data-cart-items]');
    if (!container) return;

    function apply() {
      container.querySelectorAll('[data-line][data-variant-id]').forEach(function (line) {
        var url = overrides[line.dataset.variantId];
        if (!url) return;
        var img = line.querySelector('img');
        if (img && img.getAttribute('src') !== url) img.setAttribute('src', url);
      });
    }
    apply();
    new MutationObserver(apply).observe(container, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    revealOnScroll();
    heroWordCascade();
    faqAccordions();
    heroTilt();
    gallery();
    variantSync();
    beforeAfter();
    bundlePicker();
    bundleSwatches();
    bundleAddToCart();
    buyNow();
    updateActionButtons();
    cartImageOverrides();
  });
})();
